import type { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';

import { Box, Card, Heading, Page, TextButton } from '@zillow/constellation-10';
import { PageFooter } from '@zillow/page-frame';

import LeasesHeaderNav from '../LeasesHeaderNav';
import { YOUR_RENTAL } from '../../constants/routeConstants';
import { useIsInMobileWebView } from '../../utils/mobileHandoffFunctions';
import { onPageFrameLinkClick } from '@zg-rentals/datagrail';
import { IconChevronLeftFilled } from '@zillow/constellation-icons';

type Props = {
  children?: ReactNode;
  rightSidebarContent: ReactNode;
  breadcrumbLink?: string;
  breadcrumbText?: string;
};

function ParticipantContainer({ children, rightSidebarContent, breadcrumbLink, breadcrumbText }: Props) {
  const inMobileWebView = useIsInMobileWebView();
  const history = useHistory();
  function onLinkClick() {
    if (breadcrumbLink === YOUR_RENTAL) {
      location.href = `https://zillow.com${breadcrumbLink}`;
    } else {
      history.push(`${breadcrumbLink}${window.location.search}`);
    }
  }

  return (
    <>
      {!inMobileWebView && <LeasesHeaderNav />}
      <Page.Root css={{ backgroundColor: 'bg.softer' }}>
        {breadcrumbLink && breadcrumbText && !inMobileWebView && (
          <Page.Breadcrumb>
            <TextButton onClick={onLinkClick} icon={<IconChevronLeftFilled />}>
              {breadcrumbText}
            </TextButton>
          </Page.Breadcrumb>
        )}
        <Page.Header>
          <Heading level={1}>Leases</Heading>
        </Page.Header>
        <Page.Content>
          <Box css={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: 'tight' }}>
            <Card elevated={false} tone="neutral" css={{ gridColumnEnd: { base: 'span 12', lg: 'span 8' } }}>
              {children}
            </Card>
            <Card elevated={false} tone="neutral" css={{ gridColumnEnd: { base: 'span 12', lg: 'span 4' } }}>
              {rightSidebarContent}
            </Card>
          </Box>
        </Page.Content>
      </Page.Root>
      {!inMobileWebView && <PageFooter onLinkClick={onPageFrameLinkClick} />}
    </>
  );
}

export default ParticipantContainer;
